module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"button":{"login":"Login"},"menu":{"map":"Map","about":"About"},"iteration":"Iteration: {iterationTitle}","request":{"oauth_token":"Something went wrong while trying to get your OAuth request token."}},"ko":{"button":{"login":"로그인"},"menu":{"map":"지도","about":"정보"},"iteration":"반복: {iterationTitle}","request":{"oauth_token":null}}}')
  delete Component.options._Ctor
}
